import { Helmet } from 'react-helmet-async';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen pt-20 relative z-0">
      <Helmet>
        <title>Politica de confidențialitate - dr.dent</title>
        <meta name="description" content="Politica de confidențialitate a cabinetului stomatologic dr.dent din București." />
        <link rel="canonical" href="https://drdent.ro/politica-confidentialitate" />
        <meta name="robots" content="index,follow" />
        <meta property="og:title" content="Politica de confidențialitate - dr.dent" />
        <meta property="og:description" content="Politica de confidențialitate a cabinetului stomatologic dr.dent din București." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://drdent.ro/politica-confidentialitate" />
        <meta property="og:locale" content="ro_RO" />
      </Helmet>

      <section className="bg-gradient-to-br from-primary-500 to-primary-700 text-white py-8 sm:py-12 md:py-16">
        <div className="container mx-auto px-3 sm:px-4 text-center">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-2 sm:mb-3 md:mb-4">
            Politica de confidențialitate
          </h1>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/90 max-w-2xl mx-auto px-2">
            Protecția datelor dumneavoastră personale
          </p>
        </div>
      </section>

      <section className="section bg-white py-8 sm:py-12 md:py-16">
        <div className="container mx-auto px-3 sm:px-4">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <p className="text-sm text-gray-600 mb-6"><strong>Ultima actualizare: 11.05.2026</strong></p>
            
            <p>Această Politică de confidențialitate explică modul în care site-ul drdent.ro colectează, utilizează și protejează datele cu caracter personal ale persoanelor care accesează site-ul sau care contactează cabinetul prin formular, telefon sau e-mail.</p>
            <p>Site-ul drdent.ro este un site de prezentare pentru servicii stomatologice și nu permite efectuarea de plăți online sau achiziționarea de servicii direct prin site.</p>

            <h2>1. Cine suntem</h2>
            <p>Operatorul datelor cu caracter personal este:</p>
            <p><strong>DR.CIOMAG ELENA-ANCA - CABINET MEDICAL STOMATOLOGIC</strong><br/>
            CUI: 23626870<br/>
            Sediu: Municipiul București, Sector 2, str. Grigore Ionescu, nr. 100, bl. 34, sc. A, et. P, ap. 2<br/>
            E-mail: info@drdent.com<br/>
            Telefon: 021 344 9317</p>
            <p>Pentru orice întrebare legată de prelucrarea datelor personale, ne puteți contacta la adresa de e-mail menționată mai sus.</p>

            <h2>2. Ce date personale colectăm</h2>
            <p>Putem colecta următoarele categorii de date personale:</p>
            <ul>
              <li>nume și prenume;</li>
              <li>număr de telefon;</li>
              <li>adresă de e-mail;</li>
              <li>informații transmise voluntar prin formularul de contact sau prin mesaj;</li>
              <li>informații necesare pentru programarea unei consultații;</li>
              <li>date tehnice limitate, precum adresa IP, tipul browserului, dispozitivul folosit sau informații generate prin utilizarea site-ului.</li>
            </ul>
            <p>În cazul în care ne transmiteți informații despre starea de sănătate sau despre o problemă stomatologică, acestea pot fi considerate date cu caracter special și vor fi tratate cu atenție sporită.</p>

            <h2>3. Cum colectăm datele</h2>
            <p>Datele pot fi colectate atunci când:</p>
            <ul>
              <li>completați formularul de contact;</li>
              <li>solicitați o programare;</li>
              <li>ne contactați telefonic;</li>
              <li>ne trimiteți un e-mail;</li>
              <li>accesați pagini ale site-ului care includ servicii externe, precum Google Maps.</li>
            </ul>

            <h2>4. Scopul prelucrării datelor</h2>
            <p>Folosim datele personale pentru:</p>
            <ul>
              <li>a răspunde solicitărilor primite;</li>
              <li>a confirma sau gestiona programările;</li>
              <li>a comunica informații legate de serviciile stomatologice solicitate;</li>
              <li>a îmbunătăți funcționarea site-ului;</li>
              <li>a respecta obligațiile legale aplicabile.</li>
            </ul>
            <p>Nu folosim datele personale pentru vânzarea de produse online, deoarece site-ul drdent.ro nu are funcție de magazin online.</p>

            <h2>5. Temeiul legal al prelucrării</h2>
            <p>Prelucrăm datele personale în baza unuia sau mai multor temeiuri legale:</p>
            <ul>
              <li>consimțământul persoanei vizate, atunci când ne transmite voluntar date prin formular sau e-mail;</li>
              <li>interesul legitim de a răspunde solicitărilor și de a administra site-ul;</li>
              <li>obligații legale, acolo unde este cazul;</li>
              <li>demersuri necesare înainte de prestarea unui serviciu medical, atunci când solicitați o programare.</li>
            </ul>

            <h2>6. Servicii externe</h2>
            <p>Site-ul poate integra servicii externe, precum Google Maps, pentru afișarea locației cabinetului.</p>
            <p>Atunci când interacționați cu harta sau când aceasta este încărcată în pagină, Google poate colecta anumite date tehnice, conform propriilor politici de confidențialitate.</p>

            <h2>7. Cui putem transmite datele</h2>
            <p>Datele personale pot fi transmise, dacă este necesar, către:</p>
            <ul>
              <li>furnizori de găzduire web și mentenanță site;</li>
              <li>furnizori de servicii IT;</li>
              <li>furnizori de servicii externe integrate în site, cum este Google Maps;</li>
              <li>autorități publice, dacă există o obligație legală.</li>
            </ul>
            <p>Nu vindem și nu închiriem datele personale către terți.</p>

            <h2>8. Cât timp păstrăm datele</h2>
            <p>Păstrăm datele doar atât timp cât este necesar pentru scopurile pentru care au fost colectate.</p>
            <p>Datele transmise prin formular sau e-mail pot fi păstrate pe durata necesară pentru soluționarea solicitării și, dacă este cazul, conform obligațiilor legale aplicabile.</p>

            <h2>9. Drepturile dumneavoastră</h2>
            <p>În condițiile prevăzute de legislația aplicabilă, aveți următoarele drepturi:</p>
            <ul>
              <li>dreptul de acces la date;</li>
              <li>dreptul la rectificarea datelor;</li>
              <li>dreptul la ștergerea datelor;</li>
              <li>dreptul la restricționarea prelucrării;</li>
              <li>dreptul la opoziție;</li>
              <li>dreptul la portabilitatea datelor;</li>
              <li>dreptul de a vă retrage consimțământul, acolo unde prelucrarea se bazează pe consimțământ;</li>
              <li>dreptul de a depune o plângere la autoritatea competentă.</li>
            </ul>
            <p>Pentru exercitarea acestor drepturi, ne puteți contacta la: info@drdent.com.</p>

            <h2>10. Securitatea datelor</h2>
            <p>Luăm măsuri tehnice și organizatorice rezonabile pentru protejarea datelor personale împotriva accesului neautorizat, pierderii, modificării sau divulgării neautorizate.</p>

            <h2>11. Modificări ale politicii</h2>
            <p>Această Politică de confidențialitate poate fi actualizată periodic. Versiunea actualizată va fi publicată pe această pagină, împreună cu data ultimei actualizări.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PrivacyPolicy;